const ITEMS = ["Fede", "Mente", "Corpo", "Disciplina", "Identità", "Movimento", "Comunità", "Deserto"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-ivory/10 py-6" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-2xl font-bold uppercase tracking-[0.25em] text-ivory/25 sm:text-3xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" />
          </span>
        ))}
      </div>
    </div>
  );
};
